import { Injectable } from '@angular/core';
import { Status } from 'src/app/@core/enums/status.enum';
import { FilterModel } from 'src/app/@core/models/filter.model';
import { ApplicationRoutes } from 'src/app/@core/routes/application-routes.const';
import { ApiClientService } from 'src/app/@core/services/api-client.service';
import {Observable, of} from 'rxjs';
import {GetUserNotificationsQuery, NotificationModel, NotificationResponseModel} from '../model/notification.model';
import {ResponseResult} from "../../@core/models/response.model";
import {DataFormatService} from "../../@core/services/data-format.service";

@Injectable({
  providedIn: 'root',
})
export class UserNotificationService extends DataFormatService{
  constructor(private apiService: ApiClientService) { super(); }

  Get(filterModel: FilterModel): Observable<any>  {
    return this.apiService.get(`${ApplicationRoutes.Notification.Notifications}?${this.getQueryString(filterModel)}`);
  }

  GetById(notificationId: number): Observable<NotificationModel> {
    return this.apiService.get(`${ApplicationRoutes.Notification.GetNotification(notificationId)}`);
  }

  unSeenNotifications(filterModel: FilterModel): Observable<any> {
    return this.apiService.get(`${ApplicationRoutes.Notification.UnseenNotification}?${this.getQueryString(filterModel)}`)
  }

  getList(query: GetUserNotificationsQuery = {} as GetUserNotificationsQuery): Observable<ResponseResult<NotificationResponseModel>> {
     let url: string = `${ApplicationRoutes.Notifications.Users}?${this.objectToQueryString(query)}`;
    return this.apiService.get(url);
  }
  updateSeenStatus(notificationId: number): Observable<any> {
    const url: string = ApplicationRoutes.Notifications.Seen(notificationId);
    return this.apiService.update(url, null);
  }

  getQueryString(data: FilterModel) {
    let queryString = '';
    Object.entries(data).forEach((item) => {
      if (item[1]) {
        queryString += `${item[0]}=${item[1]}&`;
      }
    });
    if (data.status == Status.Active){
      queryString += `status=${Status.Active}&`;
    }
    return queryString;
  }


}
